export default "__VITE_ASSET__C9Z9pQu2__"